const HeaderActionTypes = {
  TOGGLE_DROPDOWN_MENU: 'TOGGLE_DROPDOWN_MENU',
  TOGGLE_EXTRA_MENU: 'TOGGLE_EXTRA_MENU',
  SET_GENDER: 'SET_GENDER',
  OPEN_DROP_DOWN_MENU: 'OPEN_DROP_DOWN_MENU',
  TOGGLE_EXTRA_DROP_DOWN_MENU: 'TOGGLE_EXTRA_DROP_DOWN_MENU',
  CLOSE_ALL_DROP_DOWN_MENU: 'CLOSE_ALL_DROP_DOWN_MENU',
  SET_HEADER_GENDER: 'SET_HEADER_GENDER',
};

export default HeaderActionTypes;
